import { useEffect } from 'react'
import { GOOGLE_FONTS } from '../constants/theme'

const loadedFonts = new Set<string>()

export function useGoogleFont(fontName: string | null) {
  useEffect(() => {
    if (!fontName || loadedFonts.has(fontName) || !GOOGLE_FONTS.includes(fontName)) {
      return
    }

    const formattedName = fontName.replace(/ /g, '+')
    const link = document.createElement('link')
    link.href = `https://fonts.googleapis.com/css2?family=${formattedName}:wght@400;500;600;700&display=swap`
    link.rel = 'stylesheet'
    document.head.appendChild(link)

    loadedFonts.add(fontName)
  }, [fontName])
}

export function preloadAllFonts() {
  if (loadedFonts.size === GOOGLE_FONTS.length) return

  const families = GOOGLE_FONTS.map((f) => f.replace(/ /g, '+')).join('&family=')
  const link = document.createElement('link')
  link.href = `https://fonts.googleapis.com/css2?family=${families}:wght@400;500;600;700&display=swap`
  link.rel = 'stylesheet'
  document.head.appendChild(link)

  GOOGLE_FONTS.forEach((f) => loadedFonts.add(f))
}
